module.exports = __webpack_public_path__ + "625ee97c96d0d8a605e7ea95a974dfc6.png";